import Rox from 'rox-browser';

export const FlagsShipment = {
  revamp_enable: new Rox.Flag(false),
  revamp_enable_mac: new Rox.Flag(false),
  revamp_enable_windows: new Rox.Flag(false),
  revamp_enable_android: new Rox.Flag(false),
  revamp_enable_linux: new Rox.Flag(false),
  revamp_enable_ios: new Rox.Flag(false),
};

export function initFlagsShipment() {
  // register flags with namespaces for better grouping
  Rox.register("featureShipment", FlagsShipment);
}
